import { Component } from '@angular/core';

@Component({
  selector: 'app-eye-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './eye-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class EyeIconComponent {}
